import { Icon } from '@cloudsuite/mosaic-shared/icons/library.js'
import { dependencyContainer, FAKE, REAL } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { faBrandsFont, faLight, faRegular, faSolid, faThin } from 'elements/icon/font-awesome/current.js'
import { html, supportsAdoptingStyleSheets, svg, TemplateResult } from 'lit'


export const RENDER_ICON = Symbol('ICON_SERVICE')
export type RenderIcon = {
  renderIcon(icon: Icon): TemplateResult
}


export class FakeRenderIcon implements RenderIcon {
  renderIcon(icon: Icon): TemplateResult {
    return svg`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="currentColor" width="1em" height="1em">
        <title>fa-${icon.style} fa-${icon.name}</title>
        <circle cx="50" cy="50" r="40"/>
      </svg>`
  }
}


export class RealRenderIcon implements RenderIcon {
  constructor() {
    if (!supportsAdoptingStyleSheets) {
      // Safari < 16.4 has no constructable stylesheets.
      const fontFaces = document.createElement('style')
      fontFaces.textContent = [faLight, faRegular, faSolid, faThin, faBrandsFont].join('\n')
      document.head.append(fontFaces)
      return
    }

    const lightFontFace = new CSSStyleSheet()
    lightFontFace.replaceSync(faLight.toString())

    const regularFontFace = new CSSStyleSheet()
    regularFontFace.replaceSync(faRegular.toString())

    const solidFontFace = new CSSStyleSheet()
    solidFontFace.replaceSync(faSolid.toString())

    const thinFontFace = new CSSStyleSheet()
    thinFontFace.replaceSync(faThin.toString())

    const brandsFontFace = new CSSStyleSheet()
    brandsFontFace.replaceSync(faBrandsFont.toString())

    document.adoptedStyleSheets.push(lightFontFace, regularFontFace, solidFontFace, thinFontFace, brandsFontFace)
  }

  renderIcon(icon: Icon): TemplateResult {
    return html`
      <i class="fa-${icon.style} fa-${icon.name}"></i>
    `
  }
}


if (window.IS_STORYBOOK) {
  dependencyContainer.addDependency(REAL, RENDER_ICON, RealRenderIcon)
  dependencyContainer.addDependency(FAKE, RENDER_ICON, RealRenderIcon)
} else {
  dependencyContainer.addDependency(REAL, RENDER_ICON, RealRenderIcon)
  dependencyContainer.addDependency(FAKE, RENDER_ICON, FakeRenderIcon)
}


declare global {
  interface Window {
    IS_STORYBOOK?: boolean
  }
}
